var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0566 19.8499C24.0566 20.8052 23.3759 21.5796 22.5361 21.5796C21.6963 21.5796 21.0156 20.8052 21.0156 19.8499C21.0156 18.8947 21.6963 18.1202 22.5361 18.1202C23.376 18.1202 24.0566 18.8947 24.0566 19.8499Z",
    fill: "url(#paint0_linear_5555_84499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5361 21.9327C20.7336 21.9327 19.2725 23.2591 19.2725 24.8953C19.2725 26.1016 25.7996 26.1016 25.7996 24.8953C25.7998 23.2591 24.3386 21.9327 22.5361 21.9327Z",
    fill: "url(#paint1_linear_5555_84499)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5207 19.8499C16.5207 20.8052 15.8398 21.5796 15.0001 21.5796C14.1604 21.5796 13.4795 20.8052 13.4795 19.8499C13.4795 18.8947 14.1604 18.1202 15.0001 18.1202C15.8398 18.1202 16.5207 18.8947 16.5207 19.8499Z",
    fill: "url(#paint2_linear_5555_84499)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7363 24.8955C11.7363 26.1018 18.2635 26.1018 18.2635 24.8955C18.2635 23.2594 16.8023 21.933 14.9998 21.933C13.1975 21.9329 11.7363 23.2592 11.7363 24.8955Z",
    fill: "url(#paint3_linear_5555_84499)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98437 19.8499C8.98437 20.8052 8.30367 21.5796 7.46393 21.5796C6.62402 21.5796 5.94336 20.8052 5.94336 19.8499C5.94336 18.8947 6.62406 18.1202 7.46393 18.1202C8.30367 18.1202 8.98437 18.8947 8.98437 19.8499Z",
    fill: "url(#paint4_linear_5555_84499)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 24.8955C4.2002 26.1018 10.7273 26.1018 10.7273 24.8955C10.7273 23.2594 9.26617 21.933 7.46368 21.933C5.66132 21.9329 4.2002 23.2592 4.2002 24.8955Z",
    fill: "url(#paint5_linear_5555_84499)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.56 4.2002H13.338C13.2056 4.2002 13.0981 4.30767 13.0981 4.44027V12.2908C13.4073 12.3062 13.7433 12.332 14.058 12.3739V5.16014H24.8405V15.2401H14.058V14.4406C14.199 14.4205 14.3282 14.4006 14.4352 14.3822C14.649 14.3494 14.8117 14.1727 14.8268 13.957L18.0312 11.6596C18.1903 11.5428 18.2256 11.3196 18.1102 11.1594C17.9949 10.9992 17.7722 10.9615 17.6107 11.0752L14.3656 13.4017C13.6352 13.2756 12.8946 13.2177 12.1533 13.2284C12.1049 12.8847 11.4498 11.012 10.8284 10.3765C10.4795 10.0198 9.64513 9.68144 8.76317 9.55454L8.76334 9.55471C8.26161 9.48575 7.75302 9.48575 7.25146 9.55471C6.36955 9.68127 5.53533 10.0199 5.18626 10.3767C4.22264 11.3623 4.18262 14.2456 4.20387 16.2001H5.38597C5.57763 14.8967 5.75257 14.4016 5.88552 13.0177L6.05558 14.6327C6.06196 14.7479 6.06398 14.8634 6.0611 14.9789L6.03235 16.2001H9.98224L9.95344 14.9789C9.95074 14.8634 9.95259 14.7481 9.95897 14.6327L10.1292 13.0177C10.1841 13.1906 11.138 14.3272 11.6945 14.5321C11.931 14.6193 12.5073 14.6032 13.0981 14.5515V15.9601C13.0981 16.0239 13.1233 16.0848 13.1682 16.1298C13.2133 16.1749 13.2744 16.2001 13.338 16.2001H25.56C25.6238 16.2001 25.6847 16.1749 25.7298 16.1298C25.7748 16.0848 25.8 16.0239 25.8 15.9601V4.44005C25.8 4.37628 25.7748 4.31534 25.7298 4.27032C25.6847 4.22529 25.6238 4.20001 25.56 4.20001L25.56 4.2002Z",
    fill: "url(#paint6_linear_5555_84499)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59625 7.05133C9.59625 8.00773 8.88474 8.78301 8.00703 8.78301C7.12944 8.78301 6.41797 8.00773 6.41797 7.05133C6.41797 6.09493 7.12948 5.31964 8.00703 5.31964C8.88474 5.31964 9.59625 6.09493 9.59625 7.05133Z",
    fill: "url(#paint7_linear_5555_84499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5555_84499",
    x1: 21.0156,
    y1: 19.8499,
    x2: 24.0566,
    y2: 19.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928DAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5555_84499",
    x1: 19.2725,
    y1: 23.8664,
    x2: 25.7996,
    y2: 23.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5555_84499",
    x1: 13.4795,
    y1: 19.8499,
    x2: 16.5207,
    y2: 19.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928DAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5555_84499",
    x1: 11.7363,
    y1: 23.8666,
    x2: 18.2635,
    y2: 23.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5555_84499",
    x1: 5.94336,
    y1: 19.8499,
    x2: 8.98437,
    y2: 19.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928DAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5555_84499",
    x1: 4.2002,
    y1: 23.8666,
    x2: 10.7273,
    y2: 23.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52C234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5555_84499",
    x1: 4.2002,
    y1: 10.2001,
    x2: 25.8,
    y2: 10.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5555_84499",
    x1: 6.41797,
    y1: 7.05133,
    x2: 9.59625,
    y2: 7.05133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928DAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.b3f78386aae951d39d711b0782577a93.svg";
export { ForwardRef as ReactComponent };